<template>
    <v-content>
        <v-card>
            <v-form>
            <v-text-field
                ref="password"
                type="password"
                v-model="pass"
                v-validate="'required'"
                :error-messages="errors.collect('pass')"
                label="Pass"
                data-vv-name="pass"
                required
            ></v-text-field>
            <v-text-field
                v-model="pass2"
                type="password"
                v-validate="'required|confirmed:password'"
                :error-messages="errors.collect('pass')"
                label="Pass 2"
                data-vv-name="pass"
                required
            ></v-text-field>
        
            <v-btn @click="submit">submit</v-btn>
            <v-btn @click="clear">clear</v-btn>
            </v-form>
        </v-card>
    </v-content>
</template>

<script>

import {validator} from "vee-validate"

export default {
    name: "ChangePassword",
    data () {
        return {
            pass: '',
            pass2: "",
        }
    },
    methods: {
        submit () {
      this.$validator.validateAll()
        .then(result => {
          console.log(result)
        })
    },
    clear () {
      this.pass = ''
      this.pass2 = ''
    }
    }
}
</script>